import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { editPanelDevice } from '../actions/EditPanelDevice';
function kindLabel(kind) {
    switch (kind) {
        case 'onoff': return 'På/Av';
        case 'dim': return 'Dimmer';
        case 'rollershade': return 'Rullgardin';
        default: return '';
    }
}
export const ConfigPanelDeviceRow = (props) => {
    const dispatch = useAppDispatch();
    const panel_devices = useAppSelector(state => state.definitions.panel_devices);
    const devices = useAppSelector(state => state.definitions.devices);
    const panel_device = panel_devices.entities[props.id];
    if (!panel_device) {
        return (_jsx("div", { children: "error" }));
    }
    const device = devices[panel_device.device_id];
    if (!device) {
        return (_jsx("div", { children: "error" }));
    }
    const active = true;
    const label_classes = 'inactive label label-default' + (active ? ' hidden' : '');
    return (_jsxs("div", { className: "config-panel-transmitter-row", children: [_jsxs("div", { children: [device.title, _jsx("span", { className: label_classes, children: "Inaktiv" })] }), _jsx("div", { children: kindLabel(device.transmitter_kind) }), _jsx("div", { children: panel_device.ord }), _jsx("div", { children: _jsx("button", { className: "edit lw small", onClick: () => dispatch(editPanelDevice(props.id)), children: "\u00A0Redigera\u00A0" }) })] }));
};
